import {GenericTypeDef} from "@core/model/generic-type-def.model";
import {RetailerApplicationAssessment, ScoringBreakdown} from '@core/model/retailer/application-form.model';
import {Auditable} from "@ui-kit/framework/security/model/auditable.model";

export interface GroupedRetailerPipeline {
  bestSuited: Retailer[],
  retailerPipelines: {
    totalPages: number;
    totalElements: number;
    content: Retailer[];
  }
}

export class RetailerFilterCriteria {
  id?: number;
  curated?: ApplicationAssessmentStatus;
  tenantType?: TenantType;
}

export class Retailer extends Auditable {
  companyName!: string;
  ownerId!: number;
  externalTenantCode!: string;
  ownerFirstname!: string;
  ownerLastname!: string;
  ownerEmail!: string;
  phoneNumber!: string | null;
  socialLink!: string | null;
  websiteUrl!: string;
  addresses!: any[];
  contacts!: any[];
  curated!: ApplicationAssessmentStatus;
  industries!: RetailerIndustry[];
  logoPicUrl?: string;
  coverImageUrl?: string;
  brandImageUrl?: string;
  curationStatusUpdateRequested?: boolean;
  curationAssessment?: RetailerApplicationAssessment;
  vatReg?: string;
  overallScore!: number | null;
  scoringBreakdown!: ScoringBreakdown | null;
  usesActiveForm?: boolean;
  tenantType!: TenantType

  constructor(obj: any) {
    super(obj)
    Object.assign(this, obj);
  }
}

export interface RegisterRetailer {
  companyName: string;
  userId: number | null;
  industries: string[];
  websiteUrl?: string;
  socialMediaUrl?: string;
}

export enum ApplicationAssessmentStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  NEW = 'NEW'
}

export interface RetailerContact {
  id: number;
  contactType: GenericTypeDef;
  retailerId: number;
  valueCode: string;
  value: string;
}

export class RetailerBillingDetails {
  formattedAddress: string | null = null;
  billingName: string | null = null;
  compReg: string | null = null;
  vatReg: string | null = null;
  phoneNum: string | null = null;
  billingEmail: string | null = null;
  uuid: string | null = null;
  sameAddress?: boolean;
  addressPlace?: string;
  address?: string;
}

export class RetailerBankingDetails extends Auditable {
  bankAccountReference: string | null = null;
  retailerId: number | null = null;
  paymentMethodTypeCode: string | null = null;
  updateUserName: string | null = null;
}

export interface PaymentModel {
  accountName: string;
  bankAccountType: string;
  branchCode: string;
  bankAccountNumber: string;
  methodType: string;
  uuid?: string;
}

export interface RetailerEvent {
  id: number,
  eventTypeId: number,
  eventTypeCode: string,
  eventTypeName: string,
  userId: number,
  triggeredBy: string,
  retailerId: number,
  communityId: number,
  createDate: string
}

export class RetailerFilterDto{
  id: string | null = null;
  websiteUrl: string | null = null;
  companyName: string | null = null;
  curated: string | null = null;
  industries: number[] = [];

  constructor(id: string | null, website: string | null, companyName: string | null, curated: string | null, industries: number[]) {
    this.id = id;
    this.websiteUrl = website;
    this.companyName = companyName;
    this.curated = curated;
    this.industries = industries;
  }
}

export interface RetailerIndustry {
  id: number;
  retailerId: number;
  industryTypeId: number;
}

export enum TenantType {
  OFFERING = "OFFERING",
  TENANT = "TENANT"
}
